import { createMuiTheme } from '@material-ui/core/styles';
import { rgba } from '@zeals/shared-utils';

export default createMuiTheme({
  palette: {
    type: 'dark',
    primary: {
      main: '#4285F4',
      light: '#0057B8',
    },
    secondary: {
      main: '#1EC18D',
    },
    error: {
      main: '#E5004B',
    },
    text: {
      primary: '#000',
      secondary: '#fff',
    },
  },
  spacing: [2, 4, 8, 16, 32, 64, 128, 256, 512, 1024, 2048],
  typography: {
    fontFamily: 'Noto Sans JP',
    h6: {
      fontWeight: 'bold',
    },
    subtitle1: {
      fontWeight: 'bold',
    },
    subtitle2: {
      fontWeight: 'bold',
      color: rgba('#000', 0.2),
    },
    button: {
      fontWeight: 800,
      fontSize: 14,
    },
  },
});
